import { UserInfo } from '@vcd-ecm-ui/Common';

export const USER_INFO_REQUESTED = 'userInfoRequested';
export const USER_INFO_REQUEST_SUCCEEDED = 'userInfoRequestSucceeded';
export const USER_INFO_REQUEST_FAILED = 'userInfoRequestFailed';

interface UserInfoRequestedAction {
  type: typeof USER_INFO_REQUESTED;
}

interface UserInfoRequestSucceededAction {
  type: typeof USER_INFO_REQUEST_SUCCEEDED;
  payload: {
    userInfo: UserInfo;
  };
}

interface UserInfoRequestFailedAction {
  type: typeof USER_INFO_REQUEST_FAILED;
  error: string;
}

export type UserHookActionTypes = UserInfoRequestedAction
  | UserInfoRequestedAction
  | UserInfoRequestSucceededAction
  | UserInfoRequestFailedAction;
